//采购商企业导航菜单
export default [

    {label:'订单管理',iconClass:'icon-dingdan1',powerArr:[221,261,365,433,431,138,107,546],path:{name:'OrderLists',query:{page:1,status:'today'}},num:'order'},
    {label:'财务管理',
        iconClass:'icon-caiwuguanli',
                iconClass:'icon-Information',
        children:[
            {label:'打款申请',powerArr:[152,268,367,231,554,555],path:{name:'PayApplyList'}},
            {label:'打款记录',powerArr:[152,268,367,231,554,555],path:{name:'FinancialList'}},
            // {label:'房型资料',powerArr:[182,301,187,306,192,443,547], path:{name:'GroupRoom',query:{step:'3'}}},
            // {label:'会场资料',powerArr:[182,301,187,306,192,443,547], path:{name:'GroupMeeting',query:{step:'4'}}},
            // {label:'认证信息',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'}},
        ],
        // path:{name:'FinancialList'},
        // num:'treasurer_count'
    },
    {label:'人事管理',
        iconClass:'icon-renshiguanli',
        num:'unionRecord_count',
        powerArr:[],
        children:[
            {label:'销售列表',powerArr:[332,175,288,387,581],path:{name:'LinkedList'}},
            {label:'申请列表',powerArr:[337,170,293,392,582],path:{name:'PersonnelList'},num:'unionRecord_count'},
        ],
    },
    {label:'发票管理',iconClass:'icon-fapiaoguanli1',powerArr:[152,268,367,231,554,555],path:{name:'InvoiceManage'}},
    {label:'资料信息',
    iconClass:'icon-Information',
        children:[
            {label:'门店资料',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'}},
            {label:'企业资质',powerArr:[152,268,367,231,554,555],path:{name:'Corporateimages'}},
            {label:'银行卡管理',powerArr:[152,268,367,231,554,555],path:{name:'BankcardManage'}},
            // {label:'导游管理',powerArr:[243],path:{name:'IncomeDetail'}},
        ],
        path:{name:'InfoManage'}
    },
    // {label:'积分明细',iconClass:'icon-jifen',powerArr:[],path:{name:'GradeManage'}},
    // {label:'消息中心',iconClass:'icon-xiaoxi',powerArr:[],path:{name:'MsgLists',query:{msg_type:'2'}}},
    {label:'账号设置',iconClass:'icon-shezhi',powerArr:[],path:{name:'AccountSet'}}
]